"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
exports.validationSchema = (0, yup_1.object)().shape({
    shares: (0, yup_1.array)().of((0, yup_1.object)().shape({
        payee: yup_rules_eth_1.addressValidationSchema.test("isUnique", "form.validations.duplicate", (value, context) => {
            return context.from?.[1].value.shares?.filter(({ payee }) => payee === value).length < 2;
        }),
        share: (0, yup_1.number)()
            .typeError("form.validations.badInput")
            .min(1, "form.validations.rangeUnderflow")
            .required("form.validations.valueMissing"),
    })),
});
//# sourceMappingURL=validation.js.map